import React from 'react';
import { Input, Tooltip, DatePicker } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import moment from 'moment';
const FormItem = Form.Item;
const { TextArea } = Input;

export default ({ traspaso }) => {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  if (!traspaso) {
    return null;
  }

  return (
    <div>
      <h1 className="tituloForm">Datos de Recepción</h1>
      <Form style={{ marginTop: 50, marginRight: 40 }}>
        <FormItem
          {...formItemLayout}
          label={
            <span>
              Fecha de recepcion
              <Tooltip title="Seleccione la fecha de que se recibió el organismo">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <DatePicker
            showTime={{
              minuteStep: 10,
              format: 'HH:mm',
              defaultValue: moment('14:00:00', 'HH:mm'),
            }}
            defaultValue={moment(traspaso.fechaReal)}
            disabled={true}
            style={{ color: '#000000' }}
            format="DD-MM-YYYY HH:mm"
            placeholder="Seleccionar Fecha y Hora"
          />
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Observación
              <Tooltip title="Si lo desea, puede agregar algun comentario de la recepcion">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <TextArea
            value={traspaso.observacionRecepcion}
            disabled={true}
            rows={6}
            style={{ color: '#000000' }}
          />
        </FormItem>
      </Form>
    </div>
  );
};
